<template>
  <div class="fixed top-0 bottom-0 left-0 right-0 bg-[#F0F0F1] z-10">
    <div class="h-screen p-8 flex flex-col justify-center relative max-w-md mx-auto" data-cy="loader-component">
      <div class="relative mx-auto">
        <img class="w-[90px] animate-spin" :src="spinnerIconUrl" alt="Loading spinner" />

        <div class="absolute top-[16px] left-[16px] w-[58px] h-[58px] flex justify-center items-center rounded-full bg-primary-blue overflow-hidden">
          <img class="w-12" :src="faviconWhiteUrl" alt="Pi-xcels logo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as Sentry from '@sentry/vue';
import { onMounted, onUnmounted, ref } from 'vue';

defineProps<{
  faviconWhiteUrl: string;
  spinnerIconUrl: string;
}>();

let timer = ref<ReturnType<typeof setTimeout>>();

const captureStuckOnLoadingMessage = () => {
  Sentry.captureMessage('App is loading for more than 20 seconds');
  console.warn('App is loading for more than 20 seconds');
};

onMounted(() => {
  timer.value = setTimeout(captureStuckOnLoadingMessage, 20000);
});

onUnmounted(() => {
  clearTimeout(timer.value);
});
</script>
